/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import {
  IconButton,
  Typography,
  Button,
} from '@material-ui/core';
import {
  CloudUpload,
  Send,
} from '@material-ui/icons';
import Proptypes from 'prop-types';
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import googleStorageServices from '../../../../redux/services/googleStorageServices';
import notificationsServices from '../../../../redux/services/notificationsServices';

const AddZoomFile = ({ company, group, getFilesFromStorage }) => {
  const [file, setFile] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('uploadedFile', file);
    const upload = await googleStorageServices.uploadFile('zoom_link', company.name, group.name, data);
    if (upload.status === 200) {
      toastSuccess('File uploaded successfully');
      getFilesFromStorage();
    } else {
      toastError('File upload failed');
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        height: '100%',
        width: '50%',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '15px',
        }}
      >
        <Send style={{ color: '#757575' }} />
        <Typography variant="subtitle2">
          Envoyer un fichier
        </Typography>
      </div>
      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          border: '1.5px dashed #979797',
          padding: '20px',
          paddingBottom: '40px',
          marginBottom: '10px',
          backgroundColor: '#FFF',
          position: 'relative',
          height: '100%',
          width: '100%',
          maxWidth: '400px',
        }}
        onSubmit={handleSubmit}
        encType="multipart/form-data"
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <label htmlFor="file">
            <input
              style={{ display: 'none' }}
              id="file"
              name="file"
              type="file"
              onChange={(e) => { setFile(e.target.files[0]); }}
            />
            <IconButton
              color="primary"
              component="span"
              aria-label="add"
              variant="contained"
            >
              <CloudUpload style={{ fontSize: '40px' }} />
            </IconButton>
          </label>
          {file.name && file.name !== undefined
            ? (
              <span
                style={{
                  color: '#979797',
                  position: 'absolute',
                  left: 0,
                  top: '85px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                {file.name || 'Select a file'}
              </span>
            )
            : (
              <span
                style={{
                  color: '#979797',
                  position: 'absolute',
                  left: 0,
                  top: '85px',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                Select a file
              </span>
            )}
        </div>
      </form>
      <Button
        type="submit"
        value="Envoyer"
        variant="contained"
        color="primary"
        fullwidth
        disableElevation
        onClick={handleSubmit}
        style={{
          width: '100%',
          maxWidth: '400px',
          marginBottom: '30px',
        }}
      >
        SEND
      </Button>
    </div>
  );
};

AddZoomFile.propTypes = {
  company: Proptypes.object.isRequired,
  group: Proptypes.object.isRequired,
};

export default AddZoomFile;
